import React, { createContext, useContext, useMemo, useState } from 'react';

import { getLocalToken } from 'utilities/token';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!getLocalToken());

  const [
    modalPathologistConsultationOpen,
    setModalPathologistConsultationOpen,
  ] = useState(false);
  const [modalQCPassFailOpen, setModalQCPassFailOpen] = useState(false);
  const [modalBulkResetQCOpen, setModalBulkResetQCOpen] = useState(false);
  const [modalBulkQCPassFailOpen, setModalBulkQCPassFailOpen] = useState(false);

  const [
    snackbarPathologyConsultationOpen,
    setSnackbarPathologyConsultationOpen,
  ] = useState(false);
  const [snackbarCopied, setSnackbarCopied] = useState(false);

  const [
    modalOrderCommentsNotifyClientOpen,
    setModalOrderCommentsNotifyClientOpen,
  ] = useState(false);
  const [
    modalIHCOptimizationSlideSelectionOpen,
    setModalIHCOptimizationSlideSelectionOpen,
  ] = useState(false);

  const [algoliaClient, setAlgoliaClient] = useState(null);
  const [isPathMapFilterEnabled, setIsPathMapFilterEnabled] = useState(false);

  const updateIsLoggedIn = () => {
    setIsLoggedIn(!!getLocalToken());
  };

  const finalState = useMemo(
    () => ({
      isLoggedIn,
      modalPathologistConsultationOpen,
      modalQCPassFailOpen,
      modalBulkResetQCOpen,
      modalBulkQCPassFailOpen,
      snackbarPathologyConsultationOpen,
      snackbarCopied,
      modalOrderCommentsNotifyClientOpen,
      modalIHCOptimizationSlideSelectionOpen,
      algoliaClient,
      isPathMapFilterEnabled,
      updateIsLoggedIn,
      setModalPathologistConsultationOpen,
      setModalQCPassFailOpen,
      setModalBulkResetQCOpen,
      setModalBulkQCPassFailOpen,
      setSnackbarPathologyConsultationOpen,
      setSnackbarCopied,
      setModalOrderCommentsNotifyClientOpen,
      setModalIHCOptimizationSlideSelectionOpen,
      setAlgoliaClient,
      setIsPathMapFilterEnabled,
    }),
    [
      algoliaClient,
      isLoggedIn,
      isPathMapFilterEnabled,
      modalBulkQCPassFailOpen,
      modalBulkResetQCOpen,
      modalIHCOptimizationSlideSelectionOpen,
      modalOrderCommentsNotifyClientOpen,
      modalPathologistConsultationOpen,
      modalQCPassFailOpen,
      snackbarCopied,
      snackbarPathologyConsultationOpen,
    ],
  );

  return (
    <AppContext.Provider value={finalState}>{children}</AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
